import React from 'react'
import { isMobile } from '../../helpers/mobileresize/Mobileresize'
import WebForgot from './web/index'
import MobileForgot from './mobile/index'

const index = () =>{
    if(isMobile){
        return(
            <div>
                <MobileForgot />
            </div>
        )
    }else{
        return(
            <div>
                <WebForgot />
            </div>
        )
    }
}

export default index